// Generated by ts-to-zod
import { z } from 'zod';

export const renderEmailTemplatePayloadSchema = z.object({
  parentEmail: z.string().optional(),
  documentList: z.array(z.string()).optional(),
  annotationList: z.array(z.string()).optional(),
});
